module.exports = __webpack_public_path__ + "static/media/special-offer-title.230be4ec.svg";